var l = Object.defineProperty;
var c = (n, e, i) => e in n ? l(n, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : n[e] = i;
var t = (n, e, i) => c(n, typeof e != "symbol" ? e + "" : e, i);
import { jwtDecode as u } from "jwt-decode";
import p from "./api.mjs";
import k from "./clients/feed/index.mjs";
import f from "./clients/messages/index.mjs";
import d from "./clients/objects/index.mjs";
import m from "./clients/preferences/index.mjs";
import T from "./clients/slack/index.mjs";
import C from "./clients/users/index.mjs";
const g = "https://api.knock.app";
class z {
  constructor(e, i = {}) {
    t(this, "host");
    t(this, "apiClient", null);
    t(this, "userId");
    t(this, "userToken");
    t(this, "logLevel");
    t(this, "tokenExpirationTimer", null);
    t(this, "feeds", new k(this));
    t(this, "objects", new d(this));
    t(this, "preferences", new m(this));
    t(this, "slack", new T(this));
    t(this, "user", new C(this));
    t(this, "messages", new f(this));
    if (this.apiKey = e, this.host = i.host || g, this.logLevel = i.logLevel, this.log("Initialized Knock instance"), this.apiKey && this.apiKey.startsWith("sk_"))
      throw new Error(
        "[Knock] You are using your secret API key on the client. Please use the public key."
      );
  }
  client() {
    return this.apiClient || (this.apiClient = this.createApiClient()), this.apiClient;
  }
  /*
    Authenticates the current user. In non-sandbox environments
    the userToken must be specified.
  */
  authenticate(e, i, s) {
    let r = !1;
    this.apiClient && (this.userId !== e || this.userToken !== i) && (this.log("userId or userToken changed; reinitializing connections"), this.feeds.teardownInstances(), this.teardown(), r = !0), this.userId = e, this.userToken = i, this.log(`Authenticated with userId ${e}`), this.userToken && (s == null ? void 0 : s.onUserTokenExpiring) instanceof Function && this.maybeScheduleUserTokenExpiration(
      s.onUserTokenExpiring,
      s.timeBeforeExpirationInMs
    ), r && (this.apiClient = this.createApiClient(), this.feeds.reinitializeInstances(), this.log("Reinitialized real-time connections"));
  }
  /*
    Returns whether or this Knock instance is authenticated. Passing `true` will check the presence
    of the userToken as well.
  */
  isAuthenticated(e = !1) {
    return e ? !!(this.userId && this.userToken) : !!this.userId;
  }
  // Used to teardown any connected instances
  teardown() {
    var e;
    this.tokenExpirationTimer && clearTimeout(this.tokenExpirationTimer), (e = this.apiClient) != null && e.socket && this.apiClient.socket.isConnected() && this.apiClient.socket.disconnect();
  }
  log(e) {
    this.logLevel === "debug" && console.log(`[Knock] ${e}`);
  }
  /**
   * Initiates an API client
   */
  createApiClient() {
    return new p({
      apiKey: this.apiKey,
      host: this.host,
      userToken: this.userToken
    });
  }
  async maybeScheduleUserTokenExpiration(e, i = 3e4) {
    if (!this.userToken) return;
    const s = u(this.userToken), r = (s.exp ?? 0) * 1e3, o = Date.now();
    if (r && r > o) {
      const a = r - i - o;
      this.tokenExpirationTimer = setTimeout(async () => {
        const h = await e(this.userToken, s);
        typeof h == "string" && this.authenticate(this.userId, h, {
          onUserTokenExpiring: e,
          timeBeforeExpirationInMs: i
        });
      }, a);
    }
  }
}
export {
  z as default
};
//# sourceMappingURL=knock.mjs.map
